import SiteFooter from "../SiteFooter";
import { FooterButton } from "../FooterButton";
import HomeButton from "./HomeButton";
import PublicationButton from "./PublicationButton";
import WebinarButton from "./WebinarButton";
import ClipButton from "./ClipButton";

export default function MobileFooter({ activeButton, isHomePage = false }) {
	return (
		<>
			<div className="pb-[calc(5.5rem+env(safe-area-inset-bottom,0px))]">
				<SiteFooter isHomePage={isHomePage} />
			</div>

			<nav
				className="fixed bottom-0 left-0 right-0 z-50 border-t border-[#E8EEF5] bg-white/95 backdrop-blur-md shadow-[0_-6px_28px_rgba(15,23,42,0.08)] rounded-t-[24px] px-2 pt-1 pb-[max(0.35rem,env(safe-area-inset-bottom))]"
				aria-label="ناوبری پایین"
			>
				<div className="mx-auto flex max-w-lg items-stretch justify-between gap-0.5">
					<WebinarButton isActive={activeButton === FooterButton.WEBINARS} />
					<HomeButton
						isActive={activeButton === FooterButton.HOME || !activeButton}
					/>
					<PublicationButton
						isActive={activeButton === FooterButton.PUBLICATIONS}
					/>
					<ClipButton isActive={activeButton === FooterButton.CLIPS} />
				</div>
			</nav>
		</>
	);
}
